/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_CarrierInputs */

const vi_shipping_carrier = /** @type {(inputs: Shipping_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị vận chuyển`)
};

/**

* @param {Shipping_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier = /** @type {((inputs?: Shipping_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier(inputs)
});